import * as React from 'react';
import { TBoardId } from '../../../../../../../types/types';
import { PreviewFooterHOC } from '../../../../preview/PreviewFooter/hocs/PreviewHeaderHOC/PreviewFooterHOC';

export const getCardPreviewFooter = (
    boardId: TBoardId
): JSX.Element => {
    return (<PreviewFooterHOC boardId={boardId} />)
};
